import { useState } from 'preact/hooks';
import { apiFetch } from '../../services/api';
import { setToken } from '../../state/auth.store';
import { ShieldCheck, ArrowRight } from 'lucide-preact';

export function AuthModal() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    setError('');

    if (!password.trim()) {
      setError('Por favor, digite a senha.');
      return;
    }

    setLoading(true);
    try {
      const data = await apiFetch<{ token: string }>('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ password: password.trim() })
      });

      if (data && data.token) {
        setToken(data.token);
      } else {
        throw new Error('Servidor não retornou token de sessão.');
      }
    } catch (err: any) {
      setError(err.message || 'Senha incorreta. Verifique a senha digitada.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md">
      <div
        class="w-full max-w-md p-8 bg-slate-900 border border-slate-800 rounded-3xl shadow-2xl space-y-6 animate-fade-in"
        style={{ backgroundColor: '#0f172a', borderColor: '#1e293b' }}
      >
        <div class="flex flex-col items-center text-center space-y-2">
          <div class="w-16 h-16 mb-1 flex items-center justify-center flex-shrink-0">
            <img src="/logo.png" alt="Alfred AI Logo" class="w-full h-full object-contain drop-shadow-[0_0_12px_rgba(6,182,212,0.4)] scale-110" />
          </div>
          <h1 class="text-2xl font-bold tracking-tight text-white flex items-center gap-2">
            <span>Alfred Executivo AI</span>
          </h1>
          <p class="text-xs text-slate-400">Assistente de inteligência artificial para WhatsApp</p>
        </div>

        <form onSubmit={handleSubmit} class="space-y-4">
          <div>
            <label htmlFor="admin-password" class="block text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
              <ShieldCheck class="w-3.5 h-3.5 text-cyan-400" />
              <span>Senha de Acesso Admin</span>
            </label>
            <input
              type="password"
              id="admin-password"
              required
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
              class="w-full px-4 py-3 bg-slate-950 border border-slate-800 rounded-xl text-sm text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition"
            />
          </div>

          {error && (
            <div class="p-3 bg-rose-950/50 border border-rose-800/50 rounded-xl text-xs text-rose-300 text-center font-medium">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            class="w-full py-3 bg-cyan-600 hover:bg-cyan-500 text-white font-bold rounded-xl text-sm transition shadow-lg shadow-cyan-600/20 cursor-pointer min-h-[44px] disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <span>{loading ? 'Entrando...' : 'Entrar no Painel Executivo'}</span>
            {!loading && <ArrowRight class="w-4 h-4" />}
          </button>
        </form>
      </div>
    </div>
  );
}
